// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:45:33

export default {
  "id": "monster-merge-legends-alive",
  "slug": "monster-merge-legends-alive",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/c4425fb3edf540db8d9a56a0432f6f87-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/c4425fb3edf540db8d9a56a0432f6f87/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Monster Merge Legends Alive",
      "description": "Merge monsters! Choose more points! Drop monsters into the playing area. If they match, they will merge and become monsters of a higher rank. Your task is to unite as many monsters as possible and accumulate as many points as possible!",
      "instructions": "Press and hold your finger or mouse button within the playing area to select the monster's fall trajectory. Release your finger or mouse button and the monster will fall onto the playing field!  It will be easy to connect monsters at first, but with each new one the playing field will fill up. Drop identical monsters on top of each other. When the highest-ranking monster connects, it will disappear and you will get more points.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "collect",
        "fantasy",
        "monster"
      ]
    },
    "zh-CN": {
      "title": "怪物融合传奇：重生",
      "description": "合并怪物！选择更多点数！将怪物放入游戏区域。如果它们匹配，它们将合并并成为更高等级的怪物。你的任务是尽可能多地联合怪物，积累尽可能多的分数！",
      "instructions": "按住你的手指或鼠标按钮在游戏区域内选择怪物的下落轨迹。松开手指或鼠标按钮，怪物将落在游戏场地上！最初连接怪物会很轻松，但随着新怪物的加入，游戏场地将逐渐填满。将相同的怪物叠放在一起。当最高等级的怪物连接时，它将消失，你将获得更多分数。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "收集",
        "幻想",
        "怪物"
      ]
    },
    "zh-TW": {
      "title": "怪物合體傳說：復活",
      "description": "合併怪獸！選擇更多點數！將怪獸放入遊戲區域。如果它們匹配，它們將合併並成為更高等級的怪獸。你的任務是合併盡可能多的怪獸，積累盡可能多的點數！",
      "instructions": "按住手指或滑鼠按鈕在遊戲區域內以選擇怪獸的落下軌跡。放開手指或滑鼠按鈕，怪獸將落在遊戲場地上！最初連接怪獸會很簡單，但隨著新怪獸的加入，遊戲場地將逐漸填滿。將相同的怪獸疊放在彼此上方。當最高級的怪獸連接時，它將消失，你將獲得更多分數。",
      "genres": [
        "休闲",
        "謎題"
      ],
      "tags": [
        "收集",
        "幻想",
        "怪物"
      ]
    },
    "zh-HK": {
      "title": "怪物合體傳奇：活躍",
      "description": "合體怪物！選擇更多分數！將怪物投入遊戲區域。如果它們匹配，它們將合體並成為更高階級的怪物。你的任務是結合盡可能多的怪物，積累盡可能多的分數！",
      "instructions": "按住手指或按住滑鼠按鈕於遊戲區域內以選擇怪物下落軌跡。放開手指或滑鼠按鈕，怪物將落在遊戲區域！初期連接怪物會很簡單，但隨著新怪物的加入，遊戲區域將逐漸擁擠。將相同的怪物疊放在一併。當最高級別的怪物連接時，它將消失，你將獲得更多分數。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "收集",
        "幻想",
        "怪物"
      ]
    },
    "ja": {
      "title": "モンスター・マージ・レジェンズ・アライブ",
      "description": "モンスターを合体させろ！ポイントを選んで！モンスターをプレイエリアにドロップしろ。一致すれば、上位のモンスターに合体していくよ。あなたのタスクは、できるだけ多くのモンスターを統一し、できるだけ多くのポイントを積むことだ！",
      "instructions": "プレイエリア内で指やマウスボタンを押し続けて、モンスターの落下軌道を選んでください。指やマウスボタンを離すと、モンスターがプレイフィールドに落下します！最初はモンスターを結合させるのは簡単ですが、新しいモンスターが増えるとプレイフィールドがいっぱいになります。同じモンスターを重ねて落とします。最上位のモンスターが結合すると、消えてポイントが増えます。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "収集",
        "ファンタジー",
        "モンスター"
      ]
    },
    "ko": {
      "title": "몬스터 메이지 핸드 라이브",
      "description": "몬스터 합성! 더 많은 포인트를 선택하세요! 게임 영역에 몬스터를 내려놓으세요. 일치하면 합성되어 높은 등급의 몬스터가 됩니다. 여러분의 임무는 가능한 많은 몬스터를 연합하고 가능한 많은 포인트를 모으는 것입니다!",
      "instructions": "게임 영역 내에서 손가락이나 마우스 버튼을 누르고 유지하여 몬스터의 떨어지는 트랙을 선택하세요. 손가락이나 마우스 버튼을 떼면 몬스터가 게임 영역에 떨어집니다! 초기에는 몬스터를 연결하기 쉬우지만, 새로운 몬스터가 추가될수록 게임 영역이 가득 차게 됩니다. 동일한 몬스터를 서로 위에 내려놓세요. 가장 높은 등급의 몬스터가 연결되면 사라지고 점수가 더 많이 얻습니다.",
      "genres": [
        "캐주얼",
        "패러들"
      ],
      "tags": [
        "수집",
        "판타지",
        "몬스터"
      ]
    },
    "fr": {
      "title": "Monstre Fusion Légendes Vivantes",
      "description": "Fusionnez les monstres ! Choisissez plus de points ! Déposez les monstres dans la zone de jeu. Si ils correspondent, ils fusionneront et deviendront des monstres de rang supérieur. Votre tâche est de réunir le plus de monstres possible et d'accumuler le plus de points possible !",
      "instructions": "Appuyez et maintenez votre doigt ou le bouton de la souris dans la zone de jeu pour sélectionner la trajectoire de chute du monstre. Relâchez votre doigt ou le bouton de la souris et le monstre tombera sur le champ de jeu ! Au début, il sera facile de connecter les monstres, mais à chaque nouveau monstre, le champ de jeu se remplira. Déposez des monstres identiques les uns sur les autres. Lorsque le monstre de rang le plus élevé se connecte, il disparaitra et vous obtiendrez plus de points.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "collecter",
        "fantasy",
        "monstre"
      ]
    }
  }
};
